import { IScannedItemsList } from "./scanned-items-list";
import { OperationProduct } from "../../../../front-office/model/operation-product";

export class ScannedProductsList implements IScannedItemsList<"product", OperationProduct> {
    public readonly type = "product";
    private readonly _items: OperationProduct[];

    constructor(items: OperationProduct[]) {
        this._items = [...items];
    }

    public add(item: OperationProduct) {
        if (!this._items.find(x => x.productId === item.productId)) {
            return new ScannedProductsList([...this._items, item]);
        }

        return this;
    }

    public remove(item: OperationProduct) {
        if (this._items.find(x => x.productId === item.productId)) {
            const list = new ScannedProductsList(this._items.filter(x => x.productId !== item.productId));

            return list.items.length === 0 ? undefined : list;
        }

        return this;
    }

    get items(): OperationProduct[] {
        return this._items;
    }
}
